import React from 'react';
import PropTypes from 'prop-types';
import Button from 's2s-button';
import CallControlButton from './callControlButton';
import styled from 'styled-components';
import { getIntlText } from '../js/utilities';
import { colorGrid } from 's2s-themes';
import useCallInfo from "../hooks/callInfo";

const CallControlsContainer = styled.div`
  align-items: center;
  box-sizing : border-box;
  display: flex;
  flex-direction : column;
  height: 232px;
  min-width: 272px;
  overflow: hidden;
  background: #fff;
`;

// area that contains top two button bars
const TopContainer = styled.div`
  align-items : center;
  background: ${colorGrid.gray0};
  display : grid;
  grid-template-columns : 33% 33% 33%;
  grid-template-rows : 50% 50%;
  height : 176px;
  justify-items: center;
  width : 85%;
`;

const BottomContainer = styled.div`
  align-items : center;
  background: ${colorGrid.gray0};
  border-top: 1px solid ${colorGrid.gray3};
  display : grid;
  grid-template-columns : ${props => props.isAttendedTransfer ? '50% 50%' : '100%'};
  height : 56px;
  justify-items: center;
  width : 100%;
`;

const HangUpButton = styled(Button)`
  border-radius: 4px;
  font-weight: 600;
  justify-content : center;
  background: #C70816;
  text-transform : uppercase;
  width : ${props => props.isAttendedTransfer ? 'calc(50vw - 32px)' : 'calc(100vw - 32px)'} ;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 1.25px;
  color: #FFFFFF;
  
  &:hover {
    background: #85050F;
  }
`;

const TransferButton = styled(HangUpButton)`
  background: #099f24;
  display: ${props => props.isAttendedTransfer === true ? 'flex' : 'none'};
  width: calc(50vw - 32px);
  
  :hover {
    background: ${({ isDisabled }) => isDisabled ? '#099f24' : '#066a18'};
  }
  
`;

const CallControls = (props) => {
  const [callInfo] = useCallInfo();
  const isCallHeld = callInfo.activeCallId && callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].isHeld : false;
  const isCallMuted = callInfo.activeCallId && callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].isMuted : false;
  const isMerging = Object.keys(callInfo.inprogressCalls).length === 2 && !props.isDialing && Object.keys(callInfo.mergedCalls).length === 0;
  const isTransferDisabled = callInfo.activeCallId && callInfo.inprogressCalls[callInfo.activeCallId]
    && callInfo.inprogressCalls[callInfo.activeCallId].status === 'active' && callInfo.inprogressCalls[callInfo.activeCallId].callStatus === 'merged';

  const muteClick = (e) => {
    props.cbButtonClick('mute', undefined, e);
  };

  const holdClick = (e) => {
    props.cbButtonClick('hold', undefined, e);
  };

  const audioClick = (e) => {
    props.cbButtonClick('audio', undefined, e);
  };

  const keypadClick = (e) => {
    props.cbButtonClick('keypad', undefined, e);
  };

  const transferClick = (e) => {
    props.cbButtonClick('transfer', undefined, e);
  };

  const newCallClick = (e) => {
    props.cbButtonClick('new_call', undefined, e);
  };

  const mergeClick = (e) => {
    props.cbButtonClick('merge', undefined, e);
  };

  const hangupClick = (e) => {
    // console.log('xxxxxxxxxxxx button')
    props.cbButtonClick('hangup', undefined, e);
  };

  const completeAttendedTransferClick = (e) => {
    props.cbButtonClick('complete-attended-transfer', undefined, e);
  };

  const attendedTransferDisabled = callInfo.inprogressCalls[callInfo.activeCallId].status === 'dialing';

  console.log('CALL CONTROLS isDialing????', props.isDialing);
  return (
    <CallControlsContainer className="CallControlsWrap" >
      <TopContainer className="topContainer" >
        <CallControlButton
          className="MuteButton"
          buttonType={isCallMuted ? "red" : "white"}
          cbClick={muteClick}
          label={getIntlText(props.intl, 'CALLCONTROLS-MUTE-BTN-LABEL', "Mute")}
          svgType="MicOffRounded"
        />
        <CallControlButton
          className="PauseRounded"
          buttonType={(isCallHeld && props.isDialing) || !isCallHeld ? "white" : "red"}
          label={getIntlText(props.intl, 'CALLCONTROLS-HOLD-BTN-LABEL', "Hold")}
          cbClick={holdClick}
          isDisabled={props.isDialing}
          svgType="PauseRounded"
        />
        <CallControlButton
          className="AudioButton"
          buttonType="white"
          label={getIntlText(props.intl, 'CALLCONTROLS-AUDIO-BTN-LABEL', "Audio")}
          cbClick={audioClick}
          svgType="TuneRounded"
        />
        <CallControlButton
          className="KeypadButton"
          buttonType="white"
          label={getIntlText(props.intl, 'CALLCONTROLS-KEYPAD-BTN-LABEL', "Keypad")}
          cbClick={keypadClick}
          svgType="DialpadRounded"
        />
        <CallControlButton
          className="TransferButton"
          buttonType="white"
          isDisabled={props.isDialing || props.isAttendedTransfer || isTransferDisabled}
          label={getIntlText(props.intl, 'CALLCONTROLS-TRANSFER-BTN-LABEL', "Transfer")}
          cbClick={transferClick}
          svgType="PhoneForwardedRounded"
        />
        {!isMerging &&
          <CallControlButton
            className="NewCallButton"
            buttonType="white"
            isDisabled={
              props.isDialing ||
              props.isAttendedTransfer ||
              Object.keys(callInfo.inprogressCalls).length === 2
            }
            label={getIntlText(props.intl, 'CALLCONTROLS-NEWCALL-BTN-LABEL', "New Call")}
            cbClick={newCallClick}
            svgType="AddRounded"
          />
        }
        {isMerging &&
          <CallControlButton
            className="NewMergeButton"
            buttonType="white"
            label={getIntlText(props.intl, 'CALLCONTROLS-MERGE-BTN-LABEL', "Merge")}
            cbClick={mergeClick}
            svgType="MdCallMerge"
          />
        }
      </TopContainer>
      <BottomContainer
        className="BottomContainer"
        isAttendedTransfer={props.isAttendedTransfer}
      >
        <HangUpButton
          buttonLabel={getIntlText(props.intl, 'CALLCONTROLS-HANGUP-BTN-LABEL', "Hang Up")}
          buttonSize="large"
          cbClick={hangupClick}
          isAttendedTransfer={props.isAttendedTransfer}
        />
        <TransferButton
          buttonLabel={getIntlText(props.intl, 'CALLCONTROLS-TRANSFER-BTN-LABEL', "Transfer")}
          buttonSize="large"
          isDisabled={attendedTransferDisabled}
          buttonType="primaryGreen"
          cbClick={completeAttendedTransferClick}
          isAttendedTransfer={props.isAttendedTransfer}
        />
      </BottomContainer>
    </CallControlsContainer>
  );
};


CallControls.propTypes = {
  cbButtonClick: PropTypes.func,
  cbRefreshDevices: PropTypes.func,
  intl: PropTypes.object,
  isAttendedTransfer: PropTypes.bool,
  isDialing: PropTypes.bool, // disable HOLD, TRANSFER, and NEW CALL buttons
  isMuted: PropTypes.bool,
  isOnHold: PropTypes.bool,
  theme: PropTypes.object,
  isMerging: PropTypes.bool
};

CallControls.defaultProps = {
  cbButtonClick: () => { },
  cbRefreshDevices: () => { console.log('cbRefreshDevices is NOT defined.'); },
  isAttendedTransfer: false,
  isMuted: false,
  isOnHold: false,
  isDialing: false,
  isMerging: false,
};

export default CallControls;
